import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-user-details-skeletons',
    templateUrl: './user-details-skeletons.component.html',
    styleUrls: ['./user-details-skeletons.component.css'],
    standalone: false
})
export class UserDetailsSkeletonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
